import { useMemo } from 'react';
import { FilterableField } from 'components/organisms/tasks/fields';
import { useProjectCustomFieldsAsFilterableFields } from './use-project-custom-fields-as-filterable-fields';
import { useProjectNativeFieldsAsFilterableFields } from './use-project-native-fields-as-filterable-fields';

export const useProjectFieldsAsFilterableFields = (): {
  loading: boolean;
  fields: FilterableField[];
} => {
  const { loading: customFieldsLoading, fields: customFields } =
    useProjectCustomFieldsAsFilterableFields();
  const { loading: nativeFieldsLoading, fields: nativeFields } =
    useProjectNativeFieldsAsFilterableFields();

  return useMemo(
    () => ({
      loading: customFieldsLoading || nativeFieldsLoading,
      fields: nativeFields.concat(customFields),
    }),
    [customFields, customFieldsLoading, nativeFields, nativeFieldsLoading],
  );
};
